import * as React from "react";
import Post from "../Post/Post";
import CommentComponent from "../CommentComponent/CommentComponent";
import IPost from "../Post/IPost";
import VotePost from "../VotePost/VotePost";
import { TPitchId } from "../FeedSelect/IFeedSelect";
import IPostsList, { TPostsList } from "./IPostsList";

import * as style from "./PostsListStyles.module.scss";
import classNames from "classnames";

export default class PostContainer extends React.Component<
  IPostsList,
  TPostsList
> {
  state: TPostsList = {
    postPage: 1,
  };

  isReplyForPitch = (pitchId: TPitchId) => {
    let pitch: any = {};

    if (pitchId) {
      pitch = this.props.funding.find((pitch) => {
        return pitch.id === pitchId;
      });

      if (!pitch) pitch = {};
    }
    return Object.keys(pitch).length > 0 ? pitch : false;
  };

  displayPost = () => {
    return this.props.posts.map((elem: IPost) => {
      return (
        <div
          key={elem.id}
          className={classNames(
            elem.is_update
              ? [style.postContainerPost, style.postContainerPostOwner].join(
                  " "
                )
              : style.postContainerPost,
            {
              [style.postPinned]: elem.pinned,
            }
          )}
        >
          <Post
            {...elem}
            shouldDispalyPin
            isComment={false}
            byOwner={elem.is_update}
            repliedPitchName={this.isReplyForPitch(elem.pitch_id)}
          />
          {!elem.is_deleted && (
            <>
              <VotePost
                postId={elem.id}
                totalVotes={elem.total_votes}
                userVote={elem.current_user_vote}
              />
              <CommentComponent
                isDiscussion={this.props.isDiscussion}
                pitchId={elem.pitch_id}
                commentsList={elem.replies}
                repliesCount={elem.replies_count}
                profileAvatar={this.props.profileAvatar}
                parentId={elem.id}
                externalForum={this.props.externalForum}
              />
            </>
          )}
        </div>
      );
    });
  };

  loadMorePosts = () => {
    this.props.getFeed(this.props.posts.length + this.props.perPage);
  };

  render() {
    return (
      <div className={style.postContainer}>
        {this.displayPost()}
        {this.props.posts.length > 0 &&
          this.props.posts.length < this.props.totalCount && (
            <button
              onClick={this.loadMorePosts}
              className={style.postContainerLoadMore}
            >
              Load more
            </button>
          )}
      </div>
    );
  }
}
